const drag = () => {
  const draggables = document.querySelectorAll('.u-draggable__element');

  if (draggables.length) {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < draggables.length; i++) {
      draggables[i].addEventListener('mousedown', function(evt) {
        const offsetX =
          // eslint-disable-next-line radix
          evt.clientX - parseInt(window.getComputedStyle(this).left);
        const offsetY =
          // eslint-disable-next-line radix
          evt.clientY - parseInt(window.getComputedStyle(this).top);

        // eslint-disable-next-line no-shadow
        function mouseMoveHandler(e) {
          draggables[i].style.top = `${e.clientY - offsetY}px`;
          draggables[i].style.left = `${e.clientX - offsetX}px`;
        }

        function reset() {
          window.removeEventListener('mousemove', mouseMoveHandler);
          window.removeEventListener('mouseup', reset);
        }

        window.addEventListener('mousemove', mouseMoveHandler);
        window.addEventListener('mouseup', reset);

        window.onresize = () => {
          if (window.innerWidth < 1024) {
            draggables[i].style.top = 'auto';
            draggables[i].style.left = 'auto';
          }
        };
      });
    }
  }
};

export default drag;



// WEBPACK FOOTER //
// ./public/wp-content/themes/druckhaus/src/scripts/modules/drag.js